var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.edit_mode
    ? _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-card-title",
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.rules.title,
                      loading: _vm.save_loading,
                      clearable: "",
                      label: "Название для закупки",
                      hint: "Введите название для своей закупки",
                    },
                    model: {
                      value: _vm.purchase.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "title", $$v)
                      },
                      expression: "purchase.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-subtitle",
                [
                  _c("v-textarea", {
                    attrs: {
                      rows: "2",
                      loading: _vm.save_loading,
                      label: "Дополнительная информация",
                      hint: "Любой комментарий (какие-то новости и т.п.)",
                    },
                    model: {
                      value: _vm.purchase.info,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "info", $$v)
                      },
                      expression: "purchase.info",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-datetime-picker",
                    {
                      attrs: {
                        loading: _vm.save_loading,
                        label: "Дата начала закупки",
                        "date-format": "dd.MM.yyyy",
                        "clear-text": "Очистить",
                        "ok-text": "Готово",
                        "date-picker-props": {
                          locale: "ru-ru",
                          firstDayOfWeek: 1,
                        },
                        "time-picker-props": {
                          locale: "ru-ru",
                          format: "24hr",
                        },
                        "text-field-props": { rules: _vm.rules.required },
                      },
                      model: {
                        value: _vm.buyout_date_start,
                        callback: function ($$v) {
                          _vm.buyout_date_start = $$v
                        },
                        expression: "buyout_date_start",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "dateIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_calendar))])],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "timeIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_clock))])],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "v-datetime-picker",
                    {
                      attrs: {
                        loading: _vm.save_loading,
                        label: "Дата окончания закупки",
                        "date-format": "dd.MM.yyyy",
                        "clear-text": "Очистить",
                        "ok-text": "Готово",
                        "date-picker-props": {
                          locale: "ru-ru",
                          firstDayOfWeek: 1,
                        },
                        "time-picker-props": {
                          locale: "ru-ru",
                          format: "24hr",
                        },
                        "text-field-props": { rules: _vm.rules.required },
                      },
                      model: {
                        value: _vm.buyout_date_end,
                        callback: function ($$v) {
                          _vm.buyout_date_end = $$v
                        },
                        expression: "buyout_date_end",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "dateIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_calendar))])],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "timeIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_clock))])],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "v-datetime-picker",
                    {
                      attrs: {
                        loading: _vm.save_loading,
                        label: "Дата начала добавления заказов",
                        "date-format": "dd.MM.yyyy",
                        "clear-text": "Очистить",
                        "ok-text": "Готово",
                        "date-picker-props": {
                          locale: "ru-ru",
                          firstDayOfWeek: 1,
                        },
                        "time-picker-props": {
                          locale: "ru-ru",
                          format: "24hr",
                        },
                        "text-field-props": { rules: _vm.rules.required },
                      },
                      model: {
                        value: _vm.load_date_start,
                        callback: function ($$v) {
                          _vm.load_date_start = $$v
                        },
                        expression: "load_date_start",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "dateIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_calendar))])],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "timeIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_clock))])],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "v-datetime-picker",
                    {
                      attrs: {
                        loading: _vm.save_loading,
                        label: "Дата окончания добавления заказов",
                        "date-format": "dd.MM.yyyy",
                        "clear-text": "Очистить",
                        "ok-text": "Готово",
                        "date-picker-props": {
                          locale: "ru-ru",
                          firstDayOfWeek: 1,
                        },
                        "time-picker-props": {
                          locale: "ru-ru",
                          format: "24hr",
                        },
                        "text-field-props": { rules: _vm.rules.required },
                      },
                      model: {
                        value: _vm.load_date_end,
                        callback: function ($$v) {
                          _vm.load_date_end = $$v
                        },
                        expression: "load_date_end",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "dateIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_calendar))])],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "timeIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_clock))])],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "v-datetime-picker",
                    {
                      attrs: {
                        loading: _vm.save_loading,
                        label: "Дата окончания оплаты заказов",
                        "date-format": "dd.MM.yyyy",
                        "clear-text": "Очистить",
                        "ok-text": "Готово",
                        "date-picker-props": {
                          locale: "ru-ru",
                          firstDayOfWeek: 1,
                        },
                        "time-picker-props": {
                          locale: "ru-ru",
                          format: "24hr",
                        },
                        "text-field-props": { rules: _vm.rules.required },
                      },
                      model: {
                        value: _vm.pay_date_end,
                        callback: function ($$v) {
                          _vm.pay_date_end = $$v
                        },
                        expression: "pay_date_end",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "dateIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_calendar))])],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "timeIcon" },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.icon_clock))])],
                        1
                      ),
                    ],
                    2
                  ),
                  _c("v-switch", {
                    attrs: { loading: _vm.save_loading, inset: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: { "margin-top": "-8px" },
                                  attrs: { icon: "" },
                                  on: { click: _vm.onSettingsBackorder },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(_vm._s(_vm.icon_settings)),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(" Режим дозаказа (для опытных) "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "", "max-width": "340" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  staticClass: "grey--text",
                                                  attrs: { right: "" },
                                                },
                                                on
                                              ),
                                              [_vm._v(_vm._s(_vm.icon_help))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1836394228
                                  ),
                                },
                                [
                                  _vm._v(
                                    ' При включенном режиме дозаказа ваши клиенты смогут добавлять заказы во время вашей закупки вне зависимости от дат загрузки, но только на места, где есть заказы в статусе "Ожидает" (то есть места которые вы ещё не прошли на рынке) '
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3614881653
                    ),
                    model: {
                      value: _vm.purchase.backorder,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "backorder", $$v)
                      },
                      expression: "purchase.backorder",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "text-none font-weight-regular body-2 seccondary mr-2",
                              attrs: {
                                disabled: _vm.save_loading,
                                rounded: "",
                              },
                              on: { click: _vm.cancelEdit },
                            },
                            [_vm._v(" Отмена ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "text-none font-weight-regular body-2 success",
                              attrs: {
                                rounded: "",
                                loading: _vm.save_loading,
                                disabled: !_vm.valid,
                              },
                              on: { click: _vm.onSave },
                            },
                            [_vm._v(" Сохранить ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm.delete_mode
    ? _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "12" } },
                        [_vm._v(" Удаление закупки ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-container",
            [
              _c(
                "v-row",
                {
                  staticStyle: { height: "340px" },
                  attrs: { justify: "center", align: "center" },
                },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "text-center pb-0",
                          attrs: { "align-self": "center", cols: "12" },
                        },
                        [
                          _vm._v(
                            ' Удалить закупку "' +
                              _vm._s(_vm.purchase.title) +
                              '"? '
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "text-none font-weight-regular body-2 seccondary mr-1",
                              attrs: {
                                rounded: "",
                                disabled: _vm.delete_loading,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.delete_mode = false
                                },
                              },
                            },
                            [_vm._v(" Нет ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "text-none font-weight-regular body-2 error",
                              attrs: {
                                rounded: "",
                                loading: _vm.delete_loading,
                              },
                              on: { click: _vm.onDelete },
                            },
                            [_vm._v(" Да ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0", attrs: { cols: "10" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { "line-height": "24px" } },
                            [_vm._v(_vm._s(_vm.purchase.title))]
                          ),
                          _c(
                            "div",
                            { staticClass: "caption text--secondary" },
                            [
                              _vm._v(" #" + _vm._s(_vm.purchase.id) + " "),
                              _vm.purchase.pinned
                                ? _c("span", [_vm._v("| Закупка закреплена")])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0 text-right",
                          attrs: { cols: "2" },
                        },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                bottom: "",
                                left: "",
                                transition: "slide-y-transition",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g({ attrs: { icon: "" } }, on),
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "grey--text" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.icon_tooltip) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c(
                                "v-list",
                                _vm._l(_vm.items, function (item, i) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: i,
                                      style: {
                                        color: item.color
                                          ? `${item.color}!important`
                                          : false,
                                        opacity: item.disabled() ? 0.5 : 1,
                                      },
                                      attrs: { disabled: item.disabled() },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return item.action.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              style: {
                                                color: item.color || false,
                                              },
                                              attrs: { right: "" },
                                            },
                                            [_vm._v(_vm._s(item.icon))]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(item.title)),
                                      ]),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-subtitle",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.purchase.info,
                  expression: "purchase.info",
                },
              ],
              staticStyle: { "white-space": "pre-line" },
            },
            [_vm._v(" " + _vm._s(_vm.purchase.info) + " ")]
          ),
          _c(
            "v-card-text",
            [
              _c("v-divider", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.purchase.info,
                    expression: "purchase.info",
                  },
                ],
              }),
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "pb-1", attrs: { cols: "12" } }, [
                    _c("span", { staticStyle: { color: "rgba(0,0,0,.87)" } }, [
                      _vm._v("Период закупки"),
                    ]),
                    _vm.buyout_days_left !== -1
                      ? _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.buyout_days_left) },
                        })
                      : _c("span", [
                          _c("span", { staticClass: "error--text" }, [
                            _vm._v(" - Окончена"),
                          ]),
                        ]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "caption text--secondary pt-0",
                      staticStyle: { color: "rgba(0,0,0,.87)" },
                      attrs: { cols: "12" },
                    },
                    [
                      _vm._v(
                        " от " +
                          _vm._s(
                            _vm._f("localize")(
                              _vm.purchase.buyout_date_start,
                              "dd.MM.yyyy HH:mm"
                            )
                          ) +
                          " до " +
                          _vm._s(
                            _vm._f("localize")(
                              _vm.purchase.buyout_date_end,
                              "dd.MM.yyyy HH:mm"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "pb-1", attrs: { cols: "12" } }, [
                    _c("span", { staticStyle: { color: "rgba(0,0,0,.87)" } }, [
                      _vm._v("Добавление заказов"),
                    ]),
                    _vm.load_days_left !== -1
                      ? _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.load_days_left) },
                        })
                      : _c("span", [
                          _c("span", { staticClass: "error--text" }, [
                            _vm._v(" - Окончена"),
                          ]),
                        ]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "caption text--secondary pt-0",
                      staticStyle: { color: "rgba(0,0,0,.87)" },
                      attrs: { cols: "12" },
                    },
                    [
                      _vm._v(
                        " от " +
                          _vm._s(
                            _vm._f("localize")(
                              _vm.purchase.load_date_start,
                              "dd.MM.yyyy HH:mm"
                            )
                          ) +
                          " до " +
                          _vm._s(
                            _vm._f("localize")(
                              _vm.purchase.load_date_end,
                              "dd.MM.yyyy HH:mm"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "pb-1", attrs: { cols: "12" } }, [
                    _c("span", { staticStyle: { color: "rgba(0,0,0,.87)" } }, [
                      _vm._v("Оплата заказов"),
                    ]),
                    _vm.pay_days_left !== -1
                      ? _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.pay_days_left) },
                        })
                      : _c("span", [
                          _c("span", { staticClass: "error--text" }, [
                            _vm._v(" - Окончена"),
                          ]),
                        ]),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "caption text--secondary pt-0",
                      staticStyle: { color: "rgba(0,0,0,.87)" },
                      attrs: { cols: "12" },
                    },
                    [
                      _vm._v(
                        " до " +
                          _vm._s(
                            _vm._f("localize")(
                              _vm.purchase.pay_date_end,
                              "dd.MM.yyyy HH:mm"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "pb-2", attrs: { cols: "12" } }, [
                    _c("span", { staticStyle: { color: "rgba(0,0,0,.87)" } }, [
                      _vm._v("Режим дозаказа"),
                    ]),
                    _vm.purchase.backorder
                      ? _c("span", { staticClass: "success--text" }, [
                          _vm._v(" - Включен"),
                        ])
                      : _c("span", { staticClass: "error--text" }, [
                          _vm._v(" - Отключен"),
                        ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.has_perm("total_purchase")
            ? _c(
                "v-expansion-panels",
                {
                  staticClass: "total-collapse",
                  model: {
                    value: _vm.show_total,
                    callback: function ($$v) {
                      _vm.show_total = $$v
                    },
                    expression: "show_total",
                  },
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        { on: { click: _vm.onShowTotal } },
                        [
                          _c("div", { staticClass: "row align-center" }, [
                            _c("span", { staticClass: "title mr-2" }, [
                              _vm._v("Итоги"),
                            ]),
                            _c("span", { staticClass: "subtitle-2" }, [
                              _vm._v("(нажмите чтобы посмотреть)"),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-container",
                            { staticClass: "pa-0", attrs: { fluid: "" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "total-cell",
                                    {
                                      attrs: {
                                        error: _vm.error_total_loading,
                                        loading: _vm.total_loading,
                                        cols: "6",
                                        title: "Всего заказано",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "tooltip",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " Заказы(" +
                                                    _vm._s(
                                                      _vm.total.order_count_all
                                                    ) +
                                                    "шт) + Сборы(" +
                                                    _vm._s(
                                                      _vm.total
                                                        .collection_count_all
                                                    ) +
                                                    "шт) = " +
                                                    _vm._s(
                                                      _vm.total
                                                        .order_count_all +
                                                        _vm.total
                                                          .collection_count_all
                                                    ) +
                                                    "шт "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3031196550
                                      ),
                                    },
                                    [
                                      _vm._v(" " + _vm._s(_vm.total.count)),
                                      _c(
                                        "span",
                                        { staticClass: "text--secondary" },
                                        [_vm._v("шт")]
                                      ),
                                    ]
                                  ),
                                  _c("total-cell", {
                                    attrs: {
                                      error: _vm.error_total_loading,
                                      loading: _vm.total_loading,
                                      cols: "6",
                                      title: "Cумма заказов",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    +(
                                                      _vm.order_total_all +
                                                      _vm.collection_total_all
                                                    ).toFixed(2)
                                                  )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--secondary",
                                                },
                                                [_vm._v("₽")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "tooltip",
                                          fn: function () {
                                            return [
                                              _vm._v(" Заказы:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total.order_price_all -
                                                    _vm.total
                                                      .order_prepayment_all
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    _vm.total.order_org_all
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(_vm.order_total_all) +
                                                  "₽"
                                              ),
                                              _c("br"),
                                              _c("v-divider", {
                                                staticClass: "my-1",
                                                attrs: { color: "white" },
                                              }),
                                              _vm._v(" Сборы:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total
                                                      .collection_price_all -
                                                    _vm.total
                                                      .collection_prepayment_all
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    _vm.total.collection_org_all
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    _vm.collection_total_all
                                                  ) +
                                                  "₽"
                                              ),
                                              _c("br"),
                                              _c("v-divider", {
                                                staticClass: "my-1",
                                                attrs: { color: "white" },
                                              }),
                                              _vm._v(" Итого:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total.order_price_all +
                                                    _vm.total
                                                      .collection_price_all -
                                                    _vm.total
                                                      .order_prepayment_all -
                                                    _vm.total
                                                      .collection_prepayment_all
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    +(
                                                      _vm.total.order_org_all +
                                                      _vm.total
                                                        .collection_org_all
                                                    ).toFixed(2)
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    +(
                                                      _vm.order_total_all +
                                                      _vm.collection_total_all
                                                    ).toFixed(2)
                                                  ) +
                                                  "₽ "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1861022913
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "total-cell",
                                    {
                                      attrs: {
                                        error: _vm.error_total_loading,
                                        loading: _vm.total_loading,
                                        cols: "6",
                                        title: "Куплено",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "tooltip",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " Заказы(" +
                                                    _vm._s(
                                                      _vm.total
                                                        .order_count_purchased
                                                    ) +
                                                    "шт) + Сборы(" +
                                                    _vm._s(
                                                      _vm.total
                                                        .collection_count_purchased
                                                    ) +
                                                    "шт) = " +
                                                    _vm._s(
                                                      _vm.total
                                                        .order_count_purchased +
                                                        _vm.total
                                                          .collection_count_purchased
                                                    ) +
                                                    "шт "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1875654854
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.total.order_count_purchased +
                                              _vm.total
                                                .collection_count_purchased
                                          )
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text--secondary" },
                                        [_vm._v("шт")]
                                      ),
                                    ]
                                  ),
                                  _c("total-cell", {
                                    attrs: {
                                      error: _vm.error_total_loading,
                                      loading: _vm.total_loading,
                                      cols: "6",
                                      title: "Cумма выкупа",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    +(
                                                      _vm.order_total_purchased +
                                                      _vm.collection_total_purchased
                                                    ).toFixed(2)
                                                  )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--secondary",
                                                },
                                                [_vm._v("₽")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "tooltip",
                                          fn: function () {
                                            return [
                                              _vm._v(" Заказы:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total
                                                      .order_price_purchased -
                                                    _vm.total
                                                      .order_prepayment_purchased
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    _vm.total
                                                      .order_org_purchased
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    _vm.order_total_purchased
                                                  ) +
                                                  "₽"
                                              ),
                                              _c("br"),
                                              _c("v-divider", {
                                                staticClass: "my-1",
                                                attrs: { color: "white" },
                                              }),
                                              _vm._v(" Сборы:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total
                                                      .collection_price_purchased -
                                                    _vm.total
                                                      .collection_prepayment_purchased
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    _vm.total
                                                      .collection_org_purchased
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    _vm.collection_total_purchased
                                                  ) +
                                                  "₽"
                                              ),
                                              _c("br"),
                                              _c("v-divider", {
                                                staticClass: "my-1",
                                                attrs: { color: "white" },
                                              }),
                                              _vm._v(" Итого:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total
                                                      .order_price_purchased +
                                                    _vm.total
                                                      .collection_price_purchased -
                                                    _vm.total
                                                      .order_prepayment_purchased -
                                                    _vm.total
                                                      .collection_prepayment_purchased
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    +(
                                                      _vm.total
                                                        .order_org_purchased +
                                                      _vm.total
                                                        .collection_org_purchased
                                                    ).toFixed(2)
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    +(
                                                      _vm.order_total_purchased +
                                                      _vm.collection_total_purchased
                                                    ).toFixed(2)
                                                  ) +
                                                  "₽ "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      845334977
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "total-cell",
                                    {
                                      attrs: {
                                        error: _vm.error_total_loading,
                                        loading: _vm.total_loading,
                                        cols: "6",
                                        title: "Невыкуплено",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "tooltip",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " Заказы(" +
                                                    _vm._s(
                                                      _vm.total
                                                        .order_count_not_purchased
                                                    ) +
                                                    "шт) + Сборы(" +
                                                    _vm._s(
                                                      _vm.total
                                                        .collection_count_not_purchased
                                                    ) +
                                                    "шт) = " +
                                                    _vm._s(
                                                      _vm.total
                                                        .order_count_not_purchased +
                                                        _vm.total
                                                          .collection_count_not_purchased
                                                    ) +
                                                    "шт "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2654402054
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.total
                                              .order_count_not_purchased +
                                              _vm.total
                                                .collection_count_not_purchased
                                          )
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text--secondary" },
                                        [_vm._v("шт")]
                                      ),
                                    ]
                                  ),
                                  _c("total-cell", {
                                    attrs: {
                                      error: _vm.error_total_loading,
                                      loading: _vm.total_loading,
                                      cols: "6",
                                      title: "Cумма невыкупа",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    +(
                                                      _vm.order_total_not_purchased +
                                                      _vm.collection_total_not_purchased
                                                    ).toFixed(2)
                                                  )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--secondary",
                                                },
                                                [_vm._v("₽")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "tooltip",
                                          fn: function () {
                                            return [
                                              _vm._v(" Заказы:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total
                                                      .order_price_not_purchased -
                                                    _vm.total
                                                      .order_prepayment_not_purchased
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    _vm.total
                                                      .order_org_not_purchased
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    _vm.order_total_not_purchased
                                                  ) +
                                                  "₽"
                                              ),
                                              _c("br"),
                                              _c("v-divider", {
                                                staticClass: "my-1",
                                                attrs: { color: "white" },
                                              }),
                                              _vm._v(" Сборы:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total
                                                      .collection_price_not_purchased -
                                                    _vm.total
                                                      .collection_prepayment_not_purchased
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    _vm.total
                                                      .collection_org_not_purchased
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    _vm.collection_total_not_purchased
                                                  ) +
                                                  "₽"
                                              ),
                                              _c("br"),
                                              _c("v-divider", {
                                                staticClass: "my-1",
                                                attrs: { color: "white" },
                                              }),
                                              _vm._v(" Итого:"),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  +(
                                                    _vm.total
                                                      .order_price_not_purchased +
                                                    _vm.total
                                                      .collection_price_not_purchased -
                                                    _vm.total
                                                      .order_prepayment_not_purchased -
                                                    _vm.total
                                                      .collection_prepayment_not_purchased
                                                  ).toFixed(2)
                                                ) +
                                                  "₽ + %(" +
                                                  _vm._s(
                                                    +(
                                                      _vm.total
                                                        .order_org_not_purchased +
                                                      _vm.total
                                                        .collection_org_not_purchased
                                                    ).toFixed(2)
                                                  ) +
                                                  "₽) = " +
                                                  _vm._s(
                                                    +(
                                                      _vm.order_total_not_purchased +
                                                      _vm.collection_total_not_purchased
                                                    ).toFixed(2)
                                                  ) +
                                                  "₽ "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      964062913
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "total-cell",
                                    {
                                      attrs: {
                                        error: _vm.error_total_loading,
                                        loading: _vm.total_loading,
                                        cols: "6",
                                        sm: "6",
                                        title: "Доп. затраты",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.total.sum_expenses)
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text--secondary" },
                                        [_vm._v("₽")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "total-cell",
                                    {
                                      attrs: {
                                        error: _vm.error_total_loading,
                                        loading: _vm.total_loading,
                                        cols: "6",
                                        sm: "6",
                                        title: "Списания за доставку",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.total.sum_delivery)
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text--secondary" },
                                        [_vm._v("₽")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "total-cell",
                                    {
                                      attrs: {
                                        error: _vm.error_total_loading,
                                        loading: _vm.total_loading,
                                        cols: "6",
                                        sm: "6",
                                        title: "Доп. услуги",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.total.sum_service)
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text--secondary" },
                                        [_vm._v("₽")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "total-cell",
                                    {
                                      attrs: {
                                        error: _vm.error_total_loading,
                                        loading: _vm.total_loading,
                                        cols: "6",
                                        sm: "6",
                                        title: "Сумма предоплат",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "tooltip",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " Заказы(" +
                                                    _vm._s(
                                                      _vm.total
                                                        .order_prepayment_all
                                                    ) +
                                                    "₽) + Сборы(" +
                                                    _vm._s(
                                                      _vm.total
                                                        .collection_prepayment_all
                                                    ) +
                                                    "₽) = " +
                                                    _vm._s(
                                                      +(
                                                        _vm.total
                                                          .order_prepayment_all +
                                                        _vm.total
                                                          .collection_prepayment_all
                                                      ).toFixed(2)
                                                    ) +
                                                    "₽ "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        666988747
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            +(
                                              _vm.total.order_prepayment_all +
                                              _vm.total
                                                .collection_prepayment_all
                                            ).toFixed(2)
                                          )
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text--secondary" },
                                        [_vm._v("₽")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("v-divider"),
          _c(
            "v-container",
            { staticClass: "py-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pb-1 pb-sm-3" },
                    [
                      _vm.has_perm("market_purchase")
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn mr-2 mb-2 mb-sm-0",
                              attrs: {
                                color: "primary",
                                "min-width": "130",
                                to: {
                                  name: "purchase_market",
                                  params: { purchase_id: _vm.purchase.id },
                                },
                              },
                            },
                            [_vm._v(" Рынок ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "btn body-2 mr-2 mb-2 mb-sm-0",
                              attrs: {
                                color: "primary",
                                "min-width": "130",
                                to: {
                                  name: "purchase_albums",
                                  params: {
                                    client_id: _vm.current_client.id,
                                    purchase_id: _vm.purchase.id,
                                  },
                                },
                              },
                            },
                            [_vm._v(" Участвовать ")]
                          ),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            bottom: "",
                            left: "",
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        staticClass:
                                          "btn-gray text-none font-weight-regular body-2 mb-2 mb-sm-0",
                                        attrs: { rounded: "", outlined: "" },
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(" Доп. функции "),
                                      _c("v-icon", { attrs: { right: "" } }, [
                                        _vm._v(_vm._s(_vm.icon_menu)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _vm.has_perm("market_purchase")
                                ? _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        to: {
                                          name: "purchase_albums",
                                          params: {
                                            client_id: _vm.current_client.id,
                                            purchase_id: _vm.purchase.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Участвовать"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.has_perm("market_purchase")
                                ? _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        to: {
                                          name: "collections_sort",
                                          params: {
                                            purchaseId: _vm.purchase.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Сортировка сборов"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item",
                                {
                                  attrs: {
                                    to: {
                                      name: "purchase_histories",
                                      params: { purchase_id: _vm.purchase.id },
                                    },
                                  },
                                },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("История закупки"),
                                  ]),
                                ],
                                1
                              ),
                              _vm.has_perm("clients_purchase")
                                ? _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        to: {
                                          name: "purchase_clients",
                                          params: {
                                            purchase_id: _vm.purchase.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Клиенты закупки"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.has_perm("recalculation_percent_purchase")
                                ? _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click:
                                          _vm.openRecalculationPercentDialog,
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Перерасчет процентов"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.has_perm("purchasers_purchase")
                                ? _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        to: {
                                          name: "purchase_purchasers",
                                          params: {
                                            purchase_id: _vm.purchase.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Закупщики"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.has_perm("share_link_purchase")
                                ? _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        to: {
                                          name: "purchase_share_link",
                                          params: {
                                            purchase_id: _vm.purchase.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Ссылки продавцам"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.has_perm("download_purchase")
                                ? _c(
                                    "v-list-item",
                                    { on: { click: _vm.onDownloadPurchase } },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Выгрузить закупку в таблицу"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }